export const statusColor = {
  methods: {
    getStatusColor (status) {
      if (status === '1' || status === 1) return 'green'
      else if (status === '2' || status === 2) return 'red'
      else return 'gray'
    }
  }
}
